import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Image from '@hfe/max-image';
import LinearGradient from '@hfe/max-linear-gradient';
import Button from '@hfe/max-button';
import './index.scss';
function LandmarkItem(props) {
    const { landmark, onOpenLandmark, feConfig } = props;
    const { styleConfig } = feConfig ?? {};
    return <Button className="landmark-item" onPress={() => onOpenLandmark(landmark)}>
      <Image className="landmark-item__background" source={{
        uri: landmark.icon
    }} resizeMode='cover'/>
      <View className="landmark-item__content" style={!landmark.obtained ? {
        backgroundColor: 'rgba(0, 0, 0, 0.45)'
    } : {}}>
        <LinearGradient x-if={landmark.obtained} colors={[styleConfig?.landmarkBottomStartColor, styleConfig?.landmarkBottomEndColor]} start={{
        x: 0,
        y: 0
    }} end={{
        x: 0,
        y: 1
    }} className="landmark-item__background-gradient"/>
        <View className="landmark-item__name-wrapper">
          <Text className="landmark-item__name" numberOfLines={1} style={!landmark.obtained ? {
        color: 'rgba(255, 255, 255, 0.8)'
    } : {}}>
            {landmark.name}
          </Text>
        </View>
      </View>
    </Button>;
}
export default memo(LandmarkItem);
